import { Theme, MenuItem, TextField } from "@mui/material"
import { makeStyles } from "makeStyles"

import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
	setVariant,
} from "@secureo/common/reducers/productDetailPageReducer"

const useStyles = makeStyles()((theme: Theme) => ({
	formControl: {
		margin: theme.spacing(1),

		minWidth: 200,
	},
}))

const SimpleConfiguration = ({ reducerState, dispatch }: Props) => {
	const { classes } = useStyles()
	const {
		isLoading,
		variantId,
		variantsByVariantId,
		// attributes: { systemConfigurationToolTip },
	} = reducerState

	const onVariantChange = (variantId: number) => {
		setVariant(dispatch, reducerState, variantId)
	}

	return (
		<div>
			<div style={{ display: "flex", alignItems: "center" }}>
				<TextField
					id="variant"
					label="Ausführung"
					value={variantId}
					onChange={(event) => onVariantChange(Number(event.target.value))}
					className={classes.formControl}
					select
					margin="normal"
					variant="outlined"
					disabled={isLoading}
				>
					{Object.entries(variantsByVariantId).map(([variantId, variant]) => {
						if (Number(variantId) === 1) return null

						const variantName =
							variant?.attributes?.variantName?.replace(/.+,\s/, "") ?? variant?.sku

						return (
							<MenuItem key={variantId} value={variantId}>
								{variantName}
							</MenuItem>
						)
					})}
				</TextField>
			</div>
		</div>
	)
}

interface Props {
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
}

export default SimpleConfiguration
